import {Component} from "react";
import {Action} from "../Action/Action";
import styles from './Content.module.scss';
import cn from "classnames";

export class Content extends Component {
    state = {
        current: 0
    }

    checkoutState = (state) => {
        this.setState({ current: state })
    }

    render() {
        return (
            <div className={styles.content}>
                <div className={styles.block}>
                    <div className={cn(styles.wrapper, styles[`color-${this.state.current}`])}>
                        <Action checkoutState={this.checkoutState} />
                    </div>
                </div>
            </div>
        )
    }
}